import { Component, inject } from '@angular/core';
import { AppBootstrapErrorService } from 'app/services/app-bootstrap-error.service';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorPageRobotComponentComponent } from '../app-error-page-robot/app-error-page-robot.component.component';
import { WINDOW } from '../../utils/window';

@Component({
  imports: [
    TranslateModule,
    AppErrorPageRobotComponentComponent,
  ],
  selector: 'ecn-app-error',
  templateUrl: 'app-error.component.html',
  styleUrls: ['app-error.component.scss'],
})
export class AppErrorComponent {
  readonly appBootstrapErrorService: AppBootstrapErrorService = inject(AppBootstrapErrorService);
  private readonly injectedWindow: Window = inject(WINDOW);

  retry(): void {
    this.injectedWindow.location.replace('/');
  }
}
